import React, { useRef, useCallback, useState } from 'react';
import {
    AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter,
    AlertDialogHeader, AlertDialogOverlay, Button, Text,
} from '@chakra-ui/react';

const ConfirmDialog = ({
    isOpen,
    onClose,
    onConfirm,
    title = 'Confirmar ação',
    body = 'Tem certeza que deseja continuar?',
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    confirmColor = 'orange',
    isLoading = false,
    // Opcional: telas de celular passam um tamanho responsivo (ex.: { base: 'md', lg: 'sm' }) para alvo de toque de 40px.
    buttonSize = 'sm',
    // Opcional: no celular os botões dividem a linha e, se o texto não couber, cada um ocupa a sua.
    wrapButtons = false,
}) => {
    const flexBotao = wrapButtons ? { base: '1 1 auto', md: '0 0 auto' } : undefined;

    const cancelRef = useRef();

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            isCentered
            motionPreset="slideInBottom"
        >
            <AlertDialogOverlay>
                <AlertDialogContent mx={4}>
                    <AlertDialogHeader fontSize="md" fontWeight="bold">
                        {title}
                    </AlertDialogHeader>
                    <AlertDialogBody fontSize="sm" color="gray.700">
                        {typeof body === 'string' ? <Text>{body}</Text> : body}
                    </AlertDialogBody>
                    <AlertDialogFooter flexWrap={wrapButtons ? 'wrap' : undefined} gap={wrapButtons ? 2 : undefined}>
                        <Button ref={cancelRef} onClick={onClose} size={buttonSize} isDisabled={isLoading} flex={flexBotao}>
                            {cancelText}
                        </Button>
                        <Button
                            colorScheme={confirmColor}
                            onClick={onConfirm}
                            ml={wrapButtons ? 0 : 3}
                            size={buttonSize}
                            isLoading={isLoading}
                            flex={flexBotao}
                        >
                            {confirmText}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
};

export const useConfirm = () => {
    const [state, setState] = useState(null);

    const confirm = useCallback((options) => {
        return new Promise((resolve) => {
            setState({
                ...options,
                resolve,
            });
        });
    }, []);

    const handleConfirm = useCallback(() => {
        if (state?.resolve) state.resolve(true);
        setState(null);
    }, [state]);

    const handleCancel = useCallback(() => {
        if (state?.resolve) state.resolve(false);
        setState(null);
    }, [state]);

    const ConfirmPortal = useCallback(() => (
        <ConfirmDialog
            isOpen={!!state}
            onClose={handleCancel}
            onConfirm={handleConfirm}
            title={state?.title}
            body={state?.body}
            confirmText={state?.confirmText}
            cancelText={state?.cancelText}
            confirmColor={state?.confirmColor}
        />
    ), [state, handleCancel, handleConfirm]);

    return { confirm, ConfirmPortal };
};

export default ConfirmDialog;
